/**
 * @file   src\components\ProtectedRoute.tsx
 * @brief  This component used for manage and protect unauthorized/permission based url access.
 * @date   JULY, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {React,  Navigate, useLocation,  useParams } from '../utils/thirdpartyComponents';
import { getFromLocalStorage } from '../utils/helper';

interface Props {
  children: JSX.Element;
  // any props that come into the component
}
const ProtectedRoute = ({ children }: Props) => {
  const params = useParams();
  /* Create location object to access location info. */
  const storageData = getFromLocalStorage('CARWASH_DATA');
  const userInfo = storageData && storageData !== null ? storageData : null;
  const isAuthenticated = userInfo !== null && userInfo?.accessToken !== '';

  /* Check whether the user is authenticated or not and redirected to login page. */
  if (!isAuthenticated) {
    return <Navigate to={"/"+params.carwashname+"/"}  replace />;
  }

  return children;
};

export default ProtectedRoute;
